import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={64}
      height={30}
      viewBox="0 0 64 30"
      fill="none"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.615 15.29c0-3.452-1.695-6.175-4.936-6.175-3.255 0-5.224 2.723-5.224 6.148 0 4.058 2.325 6.108 5.661 6.108 1.628 0 2.858-.364 3.788-.877v-2.696c-.93.458-1.996.741-3.35.741-1.327 0-2.503-.458-2.653-2.049h6.687c0-.175.027-.876.027-1.2zm-6.755-1.28c0-1.524.944-2.158 1.805-2.158.834 0 1.723.633 1.723 2.157H49.86zm-8.684-4.895c-1.34 0-2.202.62-2.68 1.051l-.178-.836H35.31v15.722l3.418-.715.014-3.816c.492.351 1.217.85 2.42.85 2.448 0 4.678-1.942 4.678-6.216-.014-3.91-2.27-6.04-4.664-6.04zm-.82 9.29c-.807 0-1.286-.284-1.614-.634l-.014-5.002c.356-.391.848-.661 1.628-.661 1.244 0 2.106 1.375 2.106 3.141 0 1.807-.848 3.156-2.106 3.156zm-9.75-10.086l3.432-.728V4.854l-3.433.715v2.75zm0 1.025h3.432v11.798h-3.433V9.344zm-3.68.998l-.218-.998h-2.954v11.798h3.419v-7.996c.807-1.038 2.174-.85 2.598-.701V9.344c-.438-.162-2.038-.459-2.844.998zM20.09 6.418l-3.337.701-.013 10.8c0 1.996 1.518 3.465 3.541 3.465 1.122 0 1.942-.202 2.394-.445v-2.737c-.438.176-2.599.796-2.599-1.2v-4.786h2.599V9.344h-2.599l.014-2.926zm-9.244 6.35c0-.525.437-.728 1.162-.728 1.04 0 2.352.31 3.391.863V9.735a9.132 9.132 0 00-3.391-.62c-2.776 0-4.622 1.429-4.622 3.815 0 3.722 5.196 3.128 5.196 4.733 0 .62-.547.822-1.313.822-1.135 0-2.584-.458-3.733-1.078v3.209a9.597 9.597 0 003.733.768c2.845 0 4.8-1.388 4.8-3.802-.013-4.018-5.223-3.303-5.223-4.813z"
        fill="#0A2540"
      />
    </Svg>
  )
}

export default SvgComponent
